export default [{
  header: 'Facturación',
  icon: 'PackageIcon',
  i18n: 'Apps',
  items: [
    {
      url: { name: 'billing', params: { view: 'general' } },
      name: 'Facturación Recurrente',
      icon: 'ClipboardIcon',
      slug: 'panel',
      permiso: 'WBF100' // TODO: set permission
    },
    {
      url: { name: 'invoice-issued', params: { categoria: 'emitidos', vista: 'emitidos' } },
      name: 'Documentos Tributarios',
      slug: 'files',
      icon: 'CreditCardIcon',
      permiso: 'ED164'
    }
  ]
}];
